import React from 'react';
import { identifyComponent } from '../../../util';
import { TableHeadCell } from '../TableHeadCell';
import { useTableHeadCells } from '../useTableHeadCells';
import { TableHeadRowBase } from './Base';
import { TableHeadRowProps } from './types';

export function TableHeadRow<R>({
  columns,
  className,
  cellComponent = TableHeadCell,
  cellProps = {},
}: TableHeadRowProps<R>) {
  const headCells = useTableHeadCells(cellComponent, columns, cellProps);
  return (
    <TableHeadRowBase
      data-component="TableHeadRow"
      className={className}
      {...identifyComponent('table-head-row')}
    >
      {headCells}
    </TableHeadRowBase>
  );
}
